import React from 'react';

import { Home, About, Skills, Contact, Projects } from './container';
import { Navbar } from './components';

const Main = () => {
  return (
    <>
      <Navbar />
      <Home />
      <About />
      <Skills />
      <Projects />
      <Contact />
    </>
  );
};

export default Main;
